import type {
  DataResponse,
  ModuleCode,
  PermissionCode,
  RoleCode,
  SetRoleDefaultModulesInput,
  SetRolePermissionsInput,
} from '@tracker/shared';
import { api } from '@/lib/api';

export interface RoleSummary {
  id: string;
  code: RoleCode;
  name: string;
  description: string | null;
  is_system: boolean;
  permission_count: number;
  default_module_count: number;
}

export interface RoleDetail {
  id: string;
  code: RoleCode;
  name: string;
  description: string | null;
  is_system: boolean;
  permissions: PermissionCode[];
  default_modules: ModuleCode[];
}

export const rolesService = {
  async list(): Promise<RoleSummary[]> {
    const res = await api.get<DataResponse<RoleSummary[]>>('/roles');
    return res.data.data;
  },

  async get(code: string): Promise<RoleDetail> {
    const res = await api.get<DataResponse<RoleDetail>>(`/roles/${code}`);
    return res.data.data;
  },

  async setPermissions(code: string, input: SetRolePermissionsInput): Promise<void> {
    await api.put(`/roles/${code}/permissions`, input);
  },

  async setDefaultModules(code: string, input: SetRoleDefaultModulesInput): Promise<void> {
    await api.put(`/roles/${code}/default-modules`, input);
  },

  async applyDefaultsToAll(code: string): Promise<{ affected_count: number }> {
    const res = await api.post<DataResponse<{ affected_count: number }>>(`/roles/${code}/apply-defaults`);
    return res.data.data;
  },
};
